import * as React from 'react';
import { connect } from 'react-redux';
import './PolicyDetails.css';
import PolicyDetailsCar from './PolicyDetailsCar';
import PolicyDetailsChilli from './PolicyDetailsChilli';
import PolicyDetailsMotorbike from './PolicyDetailsMotorbike';
import PolicyDetailsContentBuilding from './PolicyDetailsContentBuilding';
import PolicyDetailsPortables from './PolicyDetailsPortables';
import PolicyDetailsWarranty from './PolicyDetailsWarranty';
import PolicyDetailsPersonalAccident from './PolicyDetailsPersonalAccident';
import PolicyDetailsCaravan from './PolicyDetailsCaravan';
import PolicyDetailsTrailer from './PolicyDetailsTrailer';
import PolicyDetailsWatercraft from './PolicyDetailsWatercraft';
import PolicyDetailsBling from './PolicyDetailsBling';
import PolicyDetailsBlingNew from './PolicyDetailsBlingNew';
import { navigateTo } from '../../../actions/navigationActions';
import PolicyDetailsCodered from './PolicyDetailsCodered';

class PolicyDetails extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            isInEdit: false,
        }
    }

    public render() {
        window.scrollTo(0, 0);
        return (
            <>
                {this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.riskItems[0].hasError &&
                    <p className="riskitem-error-banner">There was an issue recovering some details of this item.</p>
                }
                {this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 1 && 
                    <PolicyDetailsCar />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 2 &&
                    <PolicyDetailsChilli />
                }
                {
                    this.props.profile.selectedPersonalCover && (this.props.profile.selectedPersonalCover.product === 3 || this.props.profile.selectedPersonalCover.product === 4) &&
                    <PolicyDetailsContentBuilding />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 5 &&
                    <PolicyDetailsTrailer />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 6 &&
                    <PolicyDetailsPortables />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 7 &&
                    <PolicyDetailsMotorbike />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 8 &&
                    <PolicyDetailsWarranty />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 9 &&
                    <PolicyDetailsWatercraft />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 10 &&
                    <PolicyDetailsPersonalAccident />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 13 &&
                    <PolicyDetailsCaravan />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 12 &&
                    <PolicyDetailsCodered />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 21 &&
                    <PolicyDetailsBlingNew />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 22 &&
                    <PolicyDetailsBlingNew />
                }
                {
                    this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 23 &&
                    <PolicyDetailsBlingNew />
                }
            </>
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        router: state.router,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicyDetails);